import {
  CookieConsent,
  getCookieConsent,
  isCookieBannerOnPage,
  onCookieConsentUpdated,
  parseCookieConsent,
} from './cookie-consent'
import { COOKIE_MANAGEMENT_NAME, getCookie } from './cookie-helpers'
import {
  loadEssentialScripts,
  loadRecordingScripts,
  loadTrackingScripts,
} from './load-scripts'

const loadRecordingScriptsIfConsented = (consent: CookieConsent | null) => {
  if (consent?.recordingCookies) {
    loadRecordingScripts()
  }
}

// The cookie banner loads GTM itself once tracking consent is given
const loadScriptsWithCookieBanner = () => {
  loadRecordingScriptsIfConsented(getCookieConsent())
  return onCookieConsentUpdated(loadRecordingScriptsIfConsented)
}

const loadScriptsWithoutCookieBanner = () => {
  const cookieValue = getCookie(COOKIE_MANAGEMENT_NAME)
  if (!cookieValue) {
    // Load all scripts as they didn't interact with WP so we dont know preferences.
    loadTrackingScripts()
    loadRecordingScripts()
    return
  }

  const consent = parseCookieConsent(cookieValue)
  if (consent?.trackingCookies) {
    loadTrackingScripts()
  }
  loadRecordingScriptsIfConsented(consent)
}

export const handleAllowedScripts = () => {
  loadEssentialScripts()

  if (isCookieBannerOnPage()) {
    return loadScriptsWithCookieBanner()
  }

  loadScriptsWithoutCookieBanner()
  return undefined
}
